export default (prefix = '') =>
    ({ getState, dispatch }) => {
        if (window) {
            window[`_${prefix}dispatch`] = dispatch;
            window[`_${prefix}state`] = getState();
        }

        return (next) => (action) => {
            const nextAction = next(action);
            if (window) {
                window[`_${prefix}state`] = getState();
            }
            return nextAction;
        };
    };
